import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
/* MODULES */

import { getInlineStyles, getSlaveStylesClasses } from './helpers';
import { Outside } from '../outside';
/* STYLES */

import * as stylesModule from './tooltip.css';
/* TYPES */

import { CrossIcon } from '../icons/cross';
export var Slave =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Slave, _React$PureComponent);

  function Slave(props) {
    var _this;

    _classCallCheck(this, Slave);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slave).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "divRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleBackgroundClick", function (e) {
      e.stopPropagation();
    });

    _this.state = {
      rendered: false
    };
    _this.divRef = React.createRef();
    return _this;
  }

  _createClass(Slave, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2, _classNames3, _classNames4;

      var _this$props = this.props,
          children = _this$props.children,
          coords = _this$props.coords,
          styles = _this$props.styles,
          custom = _this$props.custom,
          isOpen = _this$props.isOpen,
          isHover = _this$props.isHover,
          position = _this$props.position,
          onOutside = _this$props.onOutside;
      var _custom$mediaType = custom.mediaType,
          mediaType = _custom$mediaType === void 0 ? 'all' : _custom$mediaType; // tslint:disable:strict-type-predicates

      /* istanbul ignore next line */

      if (typeof window === 'undefined') {
        /* istanbul ignore next line */
        return null;
      } // tslint:enable:strict-type-predicates


      return ReactDOM.createPortal(React.createElement("div", {
        "data-mark": "TooltipSlave",
        className: classNames(stylesModule['slave'], (_classNames = {}, _defineProperty(_classNames, stylesModule['slave-hover'], isHover), _defineProperty(_classNames, stylesModule["slave-position--".concat(position)], true), _defineProperty(_classNames, getSlaveStylesClasses({
          styles: styles,
          custom: custom
        }), true), _defineProperty(_classNames, stylesModule['slave-opened'], isOpen), _classNames)),
        style: coords,
        ref: this.divRef
      }, React.createElement("div", {
        "data-mark": "TooltipBackground",
        onClick: this.handleBackgroundClick,
        className: stylesModule['background']
      }), React.createElement(Outside, {
        onOutside: onOutside
      }, React.createElement("div", {
        className: stylesModule['outside']
      }, React.createElement("div", {
        className: classNames(stylesModule['slaveContainer'], (_classNames2 = {}, _defineProperty(_classNames2, stylesModule["slaveContainer-backgroundColor--".concat(styles.backgroundColor)], styles.backgroundColor), _defineProperty(_classNames2, stylesModule["slaveContainer-borderColor--".concat(styles.borderColor)], styles.borderColor), _classNames2)),
        style: getInlineStyles({
          styles: styles,
          custom: custom
        })
      }, React.createElement("div", {
        "data-mark": "TooltipCross",
        className: classNames(stylesModule['cross'], (_classNames3 = {}, _defineProperty(_classNames3, stylesModule['cross-hover'], isHover), _defineProperty(_classNames3, stylesModule["cross-mediaType--".concat(mediaType)], true), _classNames3)),
        onClick: function onClick(event) {
          /* istanbul ignore next line */
          event.stopPropagation();
          onOutside();
        }
      }, React.createElement(CrossIcon, {
        styles: {
          color: 'FFFFFF'
        },
        custom: {
          size: '12'
        }
      })), React.createElement("div", {
        className: classNames(stylesModule['content'], (_classNames4 = {}, _defineProperty(_classNames4, stylesModule['content-hover'], isHover), _defineProperty(_classNames4, stylesModule["content-mediaType--".concat(mediaType)], true), _classNames4))
      }, children))))), document.body);
    }
  }]);

  return Slave;
}(React.PureComponent);